module.exports = __webpack_public_path__ + "img/user-bold-rounded.14993ec1.svg";